import React from "react";
import { Link } from "react-router-dom";
import "../css/Home.css"; // Assumiamo che gli stili siano qui per ora, o potremmo spostarli

const ProductCard = ({ to, icon, title, description }) => {
  return (
    <Link to={to} className="product-card-modern">
      <div className="card-content">
        <div className="icon-wrapper">
          <img src={icon} alt={title} />
        </div>
        <h3>{title}</h3>
        <p>{description}</p>
        <span className="card-action">
          Scopri <span className="arrow">→</span>
        </span>
      </div>
      <div className="card-bg-hover"></div>
    </Link>
  );
};

export default ProductCard;
